import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { toast } from 'react-toastify';

import ButtonSp from '../../components/ButtonSp';
import { formataDataHora } from './util';

// Mostra a chave de instalacao recem-gerada. Ela aparece SO aqui: o portal guarda o
// hash, entao fechar sem copiar = gerar outra.
function DialogoChave(props) {
  DialogoChave.propTypes = {
    resultado: PropTypes.shape({
      chave: PropTypes.string,
      numeroContrato: PropTypes.number,
      nomeCliente: PropTypes.string,
      vencimento: PropTypes.string,
      diasTeste: PropTypes.number,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
  };

  const { resultado, onClose } = props;

  async function copiar() {
    try {
      await navigator.clipboard.writeText(resultado.chave);
      toast.success('Chave copiada.');
    } catch (err) {
      toast.warn('Não foi possível copiar automaticamente. Selecione e copie a chave.');
    }
  }

  const footer = (
    <div>
      <ButtonSp
        className="p-button-success"
        icon="pi pi-copy"
        label="Copiar"
        onClick={copiar}
      />
      <ButtonSp
        className="p-button-secondary"
        icon="pi pi-times"
        label="Fechar"
        onClick={onClose}
      />
    </div>
  );

  return (
    <Dialog
      closable={false}
      footer={footer}
      header="Chave de instalação"
      visible
      modal
      style={{ minWidth: '320px', maxWidth: '520px', width: '95%' }}
      onHide={onClose}
    >
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          Contrato <b>{resultado.numeroContrato}</b> - {resultado.nomeCliente}
        </div>
        <div
          className="p-col-12"
          style={{
            fontFamily: 'monospace',
            fontSize: 26,
            fontWeight: 'bold',
            letterSpacing: 2,
            textAlign: 'center',
            padding: '16px 0',
            userSelect: 'all',
          }}
        >
          {resultado.chave}
        </div>
        {resultado.diasTeste > 0 ? (
          <div className="p-col-12" style={{ color: '#856404', fontWeight: 'bold' }}>
            Licença de TESTE: {resultado.diasTeste} dia(s) a partir da ativação. Não derruba a
            instalação do cliente.
          </div>
        ) : null}
        <div className="p-col-12">
          Use uma única vez, na instalação do servidor. Vale até{' '}
          <b>{formataDataHora(resultado.vencimento)}</b>.
        </div>
        <div className="p-col-12" style={{ color: '#c0392b' }}>
          Esta chave não será mostrada de novo. Copie antes de fechar.
        </div>
      </div>
    </Dialog>
  );
}

export default DialogoChave;
